<template>
    <div
        role="button"
        class="d-flex flex-row nowrap"
        :class="alignClass || 'align-items-center'"
        style="gap: 5px"
    >
        <input
            role="button"
            :checked="props.active"
            class="ts-form-check-input my-1"
            :disabled="props.disabled"
            type="radio"
            :value="props.option?.value"
            @change="handleClick"
        />
        <label role="button" @click="handleClick">
            <slot>
                {{ props.option?.label || '' }}
            </slot>
        </label>
    </div>
</template>

<script lang="ts" setup>
import { defineProps, defineEmits } from 'vue'

type Value = string | number | boolean
type Option = {
    value: Value
    label: string
}
interface Props {
    disabled?: boolean
    option: Option
    active: boolean
    alignClass?: 'align-items-center' | 'align-items-start' | 'align-items-end'
}
interface Emits {
    (e: 'radioClick', option: Option): void
}

// props
const props = defineProps<Props>()

// emits
const emit = defineEmits<Emits>()

// handlers
const handleClick = (e: any) => {
    if (!props.disabled) emit('radioClick', props.option)
}
</script>

<style  scoped>
.ts-form-check-input:not(:checked):disabled[type='radio'] {
    background-image: none;
}
</style>
